import register from '../../../../global/js/registry';
export default register('m-breadcrumb-dynamic', () => import(/* webpackMode: "lazy" */ './m-breadcrumb-dynamic.controller'));
